<button mat-button data-test="buttons-picker" class="answer__button closecare-button primary-bg" (click)="openDialogPicker()">
    {{answer?.button.label}}
</button>